import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import FreightIQPage from "@/pages/freightiq/FreightIQPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<FreightIQPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
